<template>
  <div
    :class="[{ 'card-border before:bg-primary': selected, 'ai-support': selected && aiSupport }]"
  >
    <VCard class="flex flex-col gap-2 cursor-pointer !rounded-[12px] p-5 h-full">
      <VCardTitle class="p-0 flex justify-between items-start gap-2">
        <VTooltip
          :disabled="!titleTooltipText"
          :text="titleTooltipText"
          :location="'bottom start'"
          :open-delay="500"
        >
          <template #activator="{ props }">
            <p v-bind="props" class="text-gray-600 font-semibold text-sm">
              {{ title }}
            </p>
          </template>
        </VTooltip>

        <VIcon
          v-if="selected"
          icon="check_circle"
          color="primary"
          size="20"
          class="shrink-0"
          data-testid="widget-selected-icon"
        />
      </VCardTitle>

      <VCardItem class="p-0">
        <slot name="content" />
      </VCardItem>

      <div v-if="$slots.footer" class="mt-auto">
        <slot name="footer" />
      </div>
    </VCard>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title: string
  selected: boolean
  titleTooltipText?: string
  aiSupport?: boolean
}

defineProps<Props>()
</script>

<style scoped lang="scss">
.card-border {
  position: relative;
  border-radius: 12px;
}

.card-border::before {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: 14px;
  opacity: 1;
}

.card-border.ai-support::before {
  background: linear-gradient(90deg, #175cd3 0%, #dc6803 50%, #175cd3 100%);

  background-size: 200% 100%;
  animation: borderMove 4s linear infinite;
  opacity: 1;
}

@keyframes borderMove {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: 200%;
  }
}
</style>
